'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.set = set;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { normalize } from './trv-fed-uri';

var SET = 'urls/SET';

var initialState = {
  loaded: false
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET:
      return (0, _extends3.default)({}, state, action.urls, {
        loaded: true
      });
    default:
      return state;
  }
}

function set(urls) {
  return {
    type: SET,
    urls: urls
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/trv-fed-modules-urls.js
// module id = 1253
// module chunks = 0